import { useQuery } from '@tanstack/react-query';
import { useAuth } from './useAuth';
import type { Station, User } from '@shared/schema';

export function useStations() {
  const { user } = useAuth();
  
  // Admins get all stations, regular users get filtered stations
  const endpoint = user?.role === 'admin' ? '/api/stations' : '/api/stations/filtered';
  
  return useQuery<Station[]>({
    queryKey: [endpoint],
    enabled: !!user,
  });
}